export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/white-checkbox-check.0f83a8e8.svg","height":16,"width":16};